import PickModalClass from "./PickModalClass";

/**
 * 選択モーダル
 */
export default class SelectModalClass extends PickModalClass{
    constructor(_id,_parent){
        super(_id,_parent);
        this.name = "SelectModalClass";

        this.EVENT_CHANGE = "eventChange";

        this.Cl_ACTIVE = "isActive";

        this.onClickSelectListerner = this.onClickSelect.bind(this);

        this.index = 0;
    }

    onCreate() {
        super.onCreate();
        this.list = $("li",this.modal);
        $("a",this.list).on("click",this.onClickSelectListerner);
    }

    onClickSelect(e){
        e.preventDefault();
        const _this = $(e.currentTarget);
        const index = this.list.index(_this.closest("li"));
        const text = _this.text();
        this.list.removeClass(this.Cl_ACTIVE).eq(index).addClass(this.Cl_ACTIVE);
        //$(".text",this.clickTarget).text(text);
        this.onSetClickTargetText(text);
        this.onClose(this.EVENT_POSITIVE);
        this.index = index;
        this.jq.trigger(this.EVENT_CHANGE,{index:index,event:e});
    }

    onSetVal(_v){
        this.index = _v;
        this.list.removeClass(this.Cl_ACTIVE).eq(_v).addClass(this.Cl_ACTIVE);
        const text = this.list.eq(_v).text();
        this.onSetClickTargetText(text);

    }

    static get TYPE(){
        return "select";
    }
}